// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__htJv9","containerItemsCenter":"Skeleton_containerItemsCenter__3Atz2"};